/**
 * ConversationHeader — шапка AI-диалога.
 *
 * Слоты:
 *   icon      — Lucide-компонент слева в pill-аватаре (опц., обычно Sparkles/Bot)
 *   title     — крупный заголовок ("AI-коуч развития")
 *   subtitle  — вторая строка ("Сегодня: 3/50", "RAG · 142 статьи", и т.п.).
 *               Можно передать ReactNode для quota-pill.
 *   actions   — массив { key, icon, label, onClick, disabled, title } для
 *               icon-buttons справа. X для onClose рендерим автоматически
 *               если передан onClose.
 *   onClose   — handler для X-кнопки (если null — X не рендерится).
 */

import { X } from 'lucide-react'

export default function ConversationHeader({
    icon: Icon = null,
    title,
    subtitle = null,
    actions = [],
    onClose,
}) {
    return (
        <header className="conversation__header">
            {Icon ? (
                <span className="conversation__avatar" aria-hidden="true">
                    <Icon size={16} />
                </span>
            ) : null}

            <div className="conversation__header-text">
                <h2 className="conversation__title">{title}</h2>
                {subtitle ? (
                    <div className="conversation__subtitle">{subtitle}</div>
                ) : null}
            </div>

            <div className="conversation__header-actions">
                {actions.map((a) => {
                    const Ico = a.icon
                    return (
                        <button
                            key={a.key}
                            type="button"
                            className="conversation__icon-btn"
                            onClick={a.onClick}
                            disabled={a.disabled}
                            title={a.title || a.label}
                            aria-label={a.label || a.title}
                        >
                            {Ico ? <Ico size={16} /> : null}
                            {a.label && !Ico ? a.label : null}
                        </button>
                    )
                })}
                {onClose ? (
                    <button
                        type="button"
                        className="conversation__icon-btn"
                        onClick={onClose}
                        title="Закрыть"
                        aria-label="Закрыть"
                    >
                        <X size={18} />
                    </button>
                ) : null}
            </div>
        </header>
    )
}
